import React from 'react';
import { Row, Col } from 'react-bootstrap';

import ReadContentFromXmlForm from './ReadContentFromXmlForm';
import SearchStampingInvoiceForm from './SearchStampingInvoiceForm';

const UsePreviousCfdiToFillForm = (props) => {
  const { onChange } = props;

  return (
    <>
      <Row>
        <Col className="pt-2">
          <p>
            Para poder utilizar esta opción el comprobante debe haber sido emitido desde nuestro sistema, solo ingresa
            el folio fiscal y automáticamente completaremos la información.
          </p>
          <SearchStampingInvoiceForm onChange={onChange} />
        </Col>
      </Row>

      <Row>
        <Col className="py-2">
          <p>
            ¿El comprobante no está en nuestro sistema? No te preocupes!!! Sube tu xml y nosotros completamos la
            información por ti.
          </p>
          <ReadContentFromXmlForm onChange={onChange} />
        </Col>
      </Row>
    </>
  );
};

export default UsePreviousCfdiToFillForm;
